import { Component } from '@angular/core';
import { FormGroup,
         FormControl,
         Validators,
         FormBuilder,
         ValidatorFn,
         AbstractControl,
         ValidationErrors } from '@angular/forms';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { Response } from 'src/app/models/response';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { group } from '@angular/animations';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-modifica-password',
  templateUrl: './modifica-password.component.html',
  styleUrls: ['./modifica-password.component.css']
})
export class ModificaPasswordComponent {

  verifyPsw: string = '';
  flagPsw:boolean = false;
  profileForm: FormGroup = new FormGroup({});
  passwordErrors: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  errorFlag: boolean = false;
  showCurrent: boolean = false;
  showNew: boolean = false;
  showConfirm: boolean = false;

  constructor(private authService : AuthService,
              public dialogRef: MatDialogRef<ModificaPasswordComponent>,
              private fb: FormBuilder) {

                this.profileForm = this.fb.group({
                  current_password: new FormControl<String>('', Validators.required),
                  password: new FormControl<String>('', [Validators.required, Validators.minLength(8)]),
                  confirm_password: new FormControl<String>('', [Validators.required, Validators.minLength(8)]),
                }, {validator: this.checkPasswords});
              }

  checkPasswords: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    let pass = group.get('password')?.value;
    let verifyPass = group.get('confirm_password')?.value;
    return pass === verifyPass ? null : { notSame : true}
  }

  ngOnInit(): void{

  }

  changePassword(){

    this.authService.changePassword(this.profileForm.value).subscribe({
      next: (res: Response<any>) => {
        //  this.passwordErrors.next(res.data)

         Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: 'Password aggiornata',
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        this.dialogRef.close()

      },error: (err: any) => {

        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'error',
          iconColor: '#FFB26B',
          title: 'Password attuale errata',
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        this.profileForm.controls['current_password'].patchValue('');
      }
    })

/*     if(!this.passwordErrors.error)
    {
      this.dialogRef.close()
      this.errorFlag = false;
    }
    else this.errorFlag = true */
  }

  switchCurrent(): void {
    this.showCurrent = !this.showCurrent;
    this.showCurrent ? 'text' : 'password'
  }

  switchNew(): void {
    this.showNew = !this.showNew;
    this.showNew ? 'text' : 'password'
  }

  switchConfirm(): void {
    this.showConfirm = !this.showConfirm;
    this.showConfirm ? 'text' : 'password'
  }


}

